// @flow
import type { Sample } from "../../lib/OnlineTypes";
import React, { Fragment } from "react";
import styled from "styled-components";
import Link from "../Link";

import FixedSampleList from "../registration/FixedSampleList";
import SchedulingListToolbar from "./SchedulingListToolbar";
import SampleActionBar from "../sample_reporting/SampleActionBar";

type Props = {
  sampleIds: Array<number>
};

export default class SchedulingSampleList extends React.Component<Props> {
  state = {
    selectedSampleIds: []
  };

  canSelect = (sample: Sample) => true;

  selectedSamples = selectedSampleIds => {
    this.setState({ selectedSampleIds });
  };

  render() {
    const { sampleIds } = this.props;
    const { selectedSampleIds } = this.state;
    return (
      <div>
        <SampleActionBar
          sampleIds={selectedSampleIds}
          clientView={false}
          showEditSamples={false}
        />
        <FixedSampleList
          sampleIds={sampleIds}
          showScheduledStatus
          ToolbarComponent={SchedulingListToolbar}
          canSelect={this.canSelect}
          clientView={false}
          ExtraHeader={HeaderRow}
          ExtraBody={DataRows}
          showAttributes={false}
          onSampleSelectChange={this.selectedSamples}
        />
      </div>
    );
  }
}

function editSample(sample) {
  window.location = "/laboratory/samples/" + sample.identifier + "/edit_due_date";
}

function HeaderRow() {
  return (
    <Fragment>
      <th>Edit Turnarounds</th>
    </Fragment>
  );
}

function DataRows({ sample }) {
  return (
    <Fragment>
      <td>
        <Link onClick={() => editSample(sample)}>Edit Turnaround</Link>
      </td>
    </Fragment>
  );
}
